import React from 'react';


export const ELB = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/elb.png')} />
    )
};
